import React from 'react';
import ReactDOM from 'react-dom';

import { App } from './app';

document.addEventListener('DOMContentLoaded', () => {
  const element = document.getElementById('app');
  if (!element) throw new Error('missing #app element');

  ReactDOM.render(<App />, element);
});
